import type { CSSProperties } from 'react';

export const getEnergyZoneBackgroundColor = (color: string): string => `${color}0a`;

export const getEnergyZoneBorderColor = (color: string): string => `${color}66`;

/** Onboarding chart peaks — gradient fill blocks */
export const getPeakDipPhaseGradient = (color: string): string => {
  const isRedPhase = color === '#f34720';
  return isRedPhase
    ? 'linear-gradient(180deg, rgba(243, 71, 32, 0.1024) 0%, rgba(243, 71, 32, 0.32) 100%)'
    : 'linear-gradient(360deg, rgba(9, 194, 90, 0.1024) 0%, rgba(9, 194, 90, 0.32) 100%)';
};

/** Time-gutter lane: rounded left, open on the right to meet the calendar column */
export const getGutterEnergyZoneBlockStyle = (color: string): CSSProperties => ({
  backgroundColor: getEnergyZoneBackgroundColor(color),
  border: `1px solid ${getEnergyZoneBorderColor(color)}`,
  borderRight: 'none',
  color: `${color}80`,
});

/** Calendar day-slot lane: continues from gutter, open on the left */
export const getCalendarEnergyZoneBlockStyle = (color: string): CSSProperties => ({
  backgroundColor: getEnergyZoneBackgroundColor(color),
  border: `1px solid ${getEnergyZoneBorderColor(color)}`,
  borderLeft: 'none',
  borderRadius: '0',
  color: `${color}80`,
});
